// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2zveW","loaderOuter":"PageOverlayLoader_loaderOuter__3p5is"};